"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeTelNumber = exports.getInputPattern = void 0;
function getInputPattern(type = 'text') {
    const patterns = {
        email: () => '[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[A-Za-z]{1,63}$',
        password: () => '^[a-zA-Z0-9]+$',
        default: () => null,
    };
    return (patterns[type] || patterns['default'])();
}
exports.getInputPattern = getInputPattern;
const normalizeTelNumber = (value) => {
    if (!value)
        return value;
    const phoneNumber = value.replace(/[^\d]/g, '');
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4)
        return phoneNumber;
    else if (phoneNumberLength < 7)
        return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
    else
        return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};
exports.normalizeTelNumber = normalizeTelNumber;
